/**
 * The «Отладка» drawer (dev build only): closed on load, opened by the header
 * button (owner, 07.10.2026 — revises INV-PH-64's «always on screen»).
 *
 * Only its VISIBILITY lives here. The diagnostics journal records from page
 * load whether the drawer is open or not (`diagnostics.ts`), and an applied
 * position is session state (`sessionStore.setAgentGeo`), so closing the
 * drawer loses neither.
 */
import { isAgentFamily } from '../store/graphFamily';
import { create } from 'zustand';

export type DevTab = 'diagnostics' | 'location' | 'settings';

type DevPanel = {
  open: boolean;
  tab: DevTab;
  toggle: () => void;
  close: () => void;
  show: (tab: DevTab) => void;
};

export const useDevPanel = create<DevPanel>((set) => ({
  open: false,
  tab: 'diagnostics',
  toggle: () => set((state) => ({ open: !state.open })),
  close: () => set({ open: false }),
  show: (tab) => set({ open: true, tab }),
}));

/** The diagnostics and the position are the Agent's alone (INV-PH-64/65); the
 *  settings — graph, model, theme — are every graph's on the dev stand. */
export function devTabsFor(assistantId: string): DevTab[] {
  return isAgentFamily(assistantId) ? ['diagnostics', 'location', 'settings'] : ['settings'];
}

export const DEV_TAB_LABELS: Record<DevTab, string> = {
  diagnostics: 'Отладка',
  location: 'Местоположение',
  settings: 'Настройки',
};
